$(document).ready(function () {
  var $slider = $(".collection-list__slider");
  var $customDots = $(".custom-slider-dots");

  // Initialize Flickity
  var flkty = $slider.flickity({
    lazyLoad: 2,
    freeScroll: false,
    cellAlign: 'left',
    contain: true,
    prevNextButtons: false,
    pageDots: false,
    imagesLoaded: true,
    draggable: true,
    groupCells: '100%',
    autoPlay: true,
    autoPlay: 4000,
    wrapAround: true
  }).data('flickity');

  // Generate custom dots
  for (var i = 0; i < flkty.slides.length; i++) {
    var dot = $('<button class="custom-dot"></button>');
    dot.on('click', (function (index) {
      return function () {
        flkty.select(index);
      };
    })(i));
    $customDots.append(dot);
  }

  // Update active dot on slide change
  flkty.on('change', function (index) {
    $customDots.find('.custom-dot').removeClass('is-selected');
    $customDots.find('.custom-dot').eq(index).addClass('is-selected');
  });

  // Set the initial active dot
  $customDots.find('.custom-dot').first().addClass('is-selected');
});
